module.exports = __webpack_public_path__ + "media/images/icons/check-circle-fc0796f07951b7b2c1c2ca6384d13103.svg";